var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":function($event){return _vm.$router.push({
      path: '/detail/' + _vm.id,
      params: { id: _vm.id },
    })}}},[_vm._v(" 詳しくみる ")])}
var staticRenderFns = []

export { render, staticRenderFns }